import React from "react";
import { useSelector } from "react-redux";

import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Footer from "../../../../containers/Footer";

import PlayBtn from "../../../../assets/images/icons/play-icon.png";

import { useNavigate } from "react-router-dom";
import BackIcon from "../../../../assets/svg/BackIcon";
import { VimplayData } from "../../../../lib/data/vimplay.data";

const Vimplay = () => {
  const navigate = useNavigate();

  const { isAuth } = useSelector((state) => state.auth);
  return (
    <>
      <HeaderAfterLogin />

      <main className="main">
        <div className="slots-section">
          <div className="games-section">
            <div className="headingSec mt-0">
              <h4>Vimplay</h4>
              <div className="back-link" onClick={() => navigate(-1)}>
                <BackIcon /> Back
              </div>
            </div>

            <ul className="my-4">
              {Object.values(VimplayData).map((item) => {
                return (
                  <li className="game-section">
                    <a href={isAuth ? item.redirectUrl : "/login"}>
                      <img src={item.imgUrl} alt={item.name} />
                      <div className="casino_overlay">
                        <img src={PlayBtn} />
                      </div>
                      <p>{item.name}</p>
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default Vimplay;
